import { createContext, useContext } from "react";
import { APP_BY_TYPE } from "./app-catalog";

export type AppNavValue = {
  /** Открыть раздел на весь экран (type из app-catalog). */
  open: (type: string) => void;
  /** Вернуться к сетке всех разделов. */
  home: () => void;
  /** Текущий открытый раздел или null, если показан хаб. */
  current: string | null;
};

export const AppNavContext = createContext<AppNavValue>({
  open: () => undefined,
  home: () => undefined,
  current: null,
});

export const useAppNav = () => useContext(AppNavContext);

// открыть раздел из любого места (кнопки «Импорт», ссылки уведомлений, боковые меню разделов)
let openSection: ((type: string) => void) | null = null;
export const bindNav = (fn: ((type: string) => void) | null) => {
  openSection = fn;
};

/** Якорь макета («#contacts-import») → раздел рабочего пространства; на лендинге — скролл к блоку. false — открыть нечего. */
export function goAnchor(anchor: string): boolean {
  const raw = anchor.replace(/^#/, "").replace(/-/g, "");
  const type = ({ aiknowledge: "knowledge", aiprompts: "prompts", teamsettings: "teamsettings" } as Record<string, string>)[raw] ?? raw;
  if (openSection && APP_BY_TYPE[type]) {
    openSection(type);
    return true;
  }
  const el = document.querySelector(anchor);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }
  return false;
}
